import { Leaf } from "lucide-react";
import { useContent, rich } from "@/lib/content";
import { Reveal, SectionTitle } from "./Primitives";

export const Eco = () => {
  const { ECO, TEXTS: T } = useContent();
  return (
  <section data-testid="eco-section" className="mx-auto max-w-[1400px] px-5 pb-20 md:px-10 md:pb-28 lg:pb-40">
    <SectionTitle className="mb-12" eyebrow={T.eco_eyebrow} title={rich(T.eco_title)} testid="eco-title" />
    <div className="grid overflow-hidden rounded-[2rem] border border-gold/20 bg-roast lg:grid-cols-2">
      <div className="relative min-h-[220px] sm:min-h-[320px]">
        <img src={T.eco_photo} alt="Café Amadeus y el medio ambiente" data-testid="eco-photo" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="p-8 md:p-14">
        <ul className="grid gap-3 sm:grid-cols-2">
          {ECO.map((e, i) => (
            <Reveal key={e} delay={i * 0.05}>
              <li className="flex items-center gap-3 font-sans text-sand">
                <Leaf size={16} className="shrink-0 text-gold" /> {e}
              </li>
            </Reveal>
          ))}
        </ul>
        <Reveal>
          <p className="mt-10 border-t border-gold/15 pt-8 font-sans text-sm leading-relaxed text-sand">
            {T.eco_text}
            <span className="mt-3 block font-display text-2xl italic text-gold">{T.eco_cta}</span>
          </p>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
